import React from 'react'

import { useCurOrg } from '~/hooks/state'

import CloudClusterPage from './cloud'
import OPClusterPage from './op'

const Page: React.FC = () => {
  const { curOrg } = useCurOrg()
  const { isOP } = curOrg!

  return isOP ? <OPClusterPage /> : <CloudClusterPage />
}

export default Page
